import {Paper, Typography} from "@mui/material";

const SequenceOption = ({optionId, content, number, showNumber}) => {
    return (
        <Paper elevation={3}
               id={optionId}
               sx={{my: 1, p: 1}}
        >
            <Typography unselectable>
                {showNumber ? (number + ". ") : ""}{content}
            </Typography>
        </Paper>
    );
};

export default SequenceOption;